import Footer from "../../components/Footer"
import Navbar from "../../components/Navbar"
import TextImageSection from "../Home/component/TextImageSection"
import blogsImage from "../../assets/Images/Home/blogs.jpg"
import { Blog } from "./BlogComponent"

export const Blogs = ()=>{
  const blogs =[{
    'heading' : 'Blog heading',
    'description' : 'At FastFin, we recognize the challenges of unexpected expenses and aim to break through traditional banking barriers to provide timely.',
    'time':'5',
    'readMoreLink':'#'

  },{
    'heading' : 'Blog heading',
    'description' : 'At FastFin, we recognize the challenges of unexpected expenses and aim to break through traditional banking barriers to provide timely.',
    'time':'5',
    'readMoreLink':'#'

  },{
    'heading' : 'Blog heading',
    'description' : 'At FastFin, we recognize the challenges of unexpected expenses and aim to break through traditional banking barriers to provide timely.',
    'time':'5',
    'readMoreLink':'#'

  },{
    'heading' : 'Blog heading',
    'description' : 'At FastFin, we recognize the challenges of unexpected expenses and aim to break through traditional banking barriers to provide timely.',
    'time':'5',
    'readMoreLink':'#'

  },{
    'heading' : 'Blog heading',
    'description' : 'At FastFin, we recognize the challenges of unexpected expenses and aim to break through traditional banking barriers to provide timely.',
    'time':'5',
    'readMoreLink':'#'

  },{
    'heading' : 'Blog heading',
    'description' : 'At FastFin, we recognize the challenges of unexpected expenses and aim to break through traditional banking barriers to provide timely.',
    'time':'5',
    'readMoreLink':'#'

  }]
  return(
    <>
    <Navbar />
      <div className="home-section flex items-center">
      <TextImageSection
          view={"heading-then-image"}
          image={blogsImage}
          heading={"Empowering Your Financial Decisions"}
          custumeClass="center-section leading-partner image-hr-text insta-loan credit-tool-instaloan loan-product-page blogs-page"
        ></TextImageSection>

      </div>
      <div className="blog-section">
        <h2 className="blog-title">Explore our blog</h2>
        <div className="blogs-section-container">
          <Blog blogs={blogs}/>
        </div>        
    </div>
    <Footer custumeClass="landing-page-footer !bg-inherit !border-0" />
    </>
  )
}